<template>
	<div class="wrapper-jishen">
		<card class="base-info-new">
			<div class="base-info-top">
				<div class="id-card-pic">
					<el-image
						style="
							width: 100px;
							border-radius: 8px;
							height: 100px;
							margin-right: 10px;
						"
						:src="member.identityFrontImageUrl"
						:preview-src-list="[member.identityFrontImageUrl]"
					>
						<div
							style="
								background: #f5f7fa;
								width: 100px;
								height: 100px;
								line-height: 100px;
								text-align: center;
								color: #c0c4cc;
							"
							slot="error"
						>
							暂无图片
						</div>
					</el-image>
					<el-image
						style="width: 100px; border-radius: 8px; height: 100px"
						:src="member.identityBackImageUrl"
						:preview-src-list="[member.identityBackImageUrl]"
					>
						<div
							style="
								background: #f5f7fa;
								width: 100px;
								height: 100px;
								line-height: 100px;
								text-align: center;
								color: #c0c4cc;
							"
							slot="error"
						>
							暂无图片
						</div>
					</el-image>
				</div>
				<div class="person-info">
					<div>
						<span class="name fw700">{{ member.memberName }}</span>
						<el-tag type="success">年龄：{{ member.age }}</el-tag>
						<el-tag type="success">性别：{{ member.genderName }}</el-tag>
						<span v-for="(item, i) in detail.rosterLevelList" :key="i">
							<span class="tag-ku t3" v-if="item == 1" style="margin: 2px"
								>白名单</span
							>
							<span class="tag-ku t1" v-if="item == 2" style="margin: 2px"
								><i class="el-icon-warning"></i>黑名单</span
							>
							<span class="tag-ku t2" v-if="item == 3" style="margin: 2px"
								><i class="el-icon-warning"></i>灰名单</span
							>
						</span>
					</div>
					<div>
						<span class="mr50">
              <span class="label">手机号：</span>
              <span class="fw700">{{ member.mobile }}</span>
            </span>
            <span>
              <span class="label">身份证号：</span>
              <span class="fw700">{{ member.identityNo }}</span>
            </span>
					</div>
					<div>
						<span>
              <span class="label">户籍所在地：</span>
              <span class="fw700">{{ member.identityAddress || "" }}</span>
            </span>
					</div>
<!--					<div class="rating" v-if="enableHitScore">
						<TagLvNew :name="detail.sysHitGrade ? detail.sysHitGrade : 'ZW'" />
						<p>系统评级</p>
					</div>-->
				</div>
			</div>
		</card>

		<!-- 客户评级 -->
<!--		<template v-if="enableHitScore">
      <LevelProgress
          :scoreProfileData="detail"
          :sysScore="detail.sysHitScore"
          :sysLevel="detail.sysHitGrade"
          :style="{ marginBottom: '20px' }"
      />
    </template>-->

    <template>
      <div style="margin-bottom: 20px;"></div>
    </template>

<!--		<card class="card" v-if="enableHitScore">
			<AdminTitle title="系统评分详情" size="20px"></AdminTitle>
			<el-table :data="systemScoreDetail">
				<el-table-column label="序号" prop="index" width="120px"></el-table-column>
				<el-table-column label="评分项命中规则" prop="ruleName"></el-table-column>
				<el-table-column label="分值" prop="hitScore">
					<template slot-scope="{ row }">
						<span class="danger-cell">{{ row.hitScore }}</span>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="hitSuggestDesc">
					<template slot-scope="{ row }">
						<span class="danger-cell">{{ row.hitSuggestDesc }}</span>
					</template>
        </el-table-column>
			</el-table>
		</card>-->

<!--		<card class="card">
			<AdminTitle title="宝系智租风险评估" size="20px"></AdminTitle>
			<el-table :data="riskListTable">
				<el-table-column label="风险项" prop="riskName"></el-table-column>
				<el-table-column label="风险等级" prop="riskRank">
					<template slot-scope="{ row }">
						<div
							class="rank-tag"
							:style="{
								backgroundColor: rankToColorMap.get(row.riskRank).color,
							}"
						>
							{{ rankToColorMap.get(row.riskRank).label }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="审核建议（仅供参考）" prop="riskDesc" />
			</el-table>
		</card>-->

		<card class="card">
			<AdminTitle title="重点关注" size="20px"></AdminTitle>
			<el-table :data="importantInfoMark">
				<el-table-column label="数据来源" prop="name" />
				<el-table-column label="风险项" prop="riskName" />
				<el-table-column label="数据" prop="riskValue">
					<template slot-scope="{ row }">
						<span :class="{ ['danger-cell']: row.name === '百融' }">
              {{ row.riskValue }}
            </span>
					</template>
				</el-table-column>
			</el-table>
		</card>

    <card class="card">
      <AdminTitle title="优分法诉汇总" size="20px"></AdminTitle>
      <el-table :data="courtRiskInfo" :style="{ marginBottom: '30px' }">
        <el-table-column label="个人涉诉总数" prop="count">
          <template slot-scope="{ row }">
            <span class="danger-cell">{{ row.count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="裁判文书" prop="judgeDocumentCount" />
        <el-table-column label="开庭公告" prop="openCourtNoticeCount" />
        <el-table-column label="执行公告" prop="executeNoticeCount" />
        <el-table-column label="失信公告" prop="dishonestyNoticeCount" />
        <el-table-column label="案件流程" prop="caseProduceCount" />
        <el-table-column label="曝光台" prop="exposureCount" />
      </el-table>
      <el-table :data="personInvolvement">
        <el-table-column label="序号" prop="index" width="100" />
        <el-table-column label="日期" prop="caseTime" width="150" />
        <el-table-column label="类型" prop="dataType" width="150" />
        <el-table-column label="标题" prop="title" />
        <el-table-column label="内容摘要" prop="content" />
      </el-table>
    </card>

    <card class="card">
      <AdminTitle title="优分多头汇总" size="20px"></AdminTitle>
      <el-table :data="yfMulti1Info" :style="{ marginBottom: '30px' }">
        <el-table-column label="申请机构总数" prop="applyOrgNum" />
        <el-table-column label="近12个月逾期次数" prop="m12OverdueNum" />
        <el-table-column label="近24个月逾期次数" prop="m24OverdueNum" />
      </el-table>
      <el-table :data="yfMulti2Info" :style="{ marginBottom: '30px' }">
        <el-table-column label="最近逾期距今天数" prop="overdueRecentlyDay" />
        <el-table-column label="最早逾期距今天数" prop="overdueHistoryDay" />
        <el-table-column label="逾期最大金额距今最近天数" prop="overdueMaxMoneyRecentlyDay" />
        <el-table-column label="逾期最大金额距今最早天数" prop="overdueMaxMoneyHistoryDay" />
      </el-table>
    </card>

    <card class="card">
      <AdminTitle title="百融贷前汇总" size="20px"></AdminTitle>
      <el-table :data="brApplyRecord" :style="{ marginBottom: '20px' }">
        <el-table-column prop="title">
          <p slot="header" class="table-svg-header">
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.91675 3.33317C2.91675 2.4127 3.66294 1.6665 4.58341 1.6665H13.6786L17.0834 5.07133V16.6665C17.0834 17.587 16.3372 18.3332 15.4167 18.3332H4.58341C3.66294 18.3332 2.91675 17.587 2.91675 16.6665V3.33317ZM12.9882 3.33317L4.58341 3.33317V16.6665H15.4167V5.76168L12.9882 3.33317Z"
                  fill="#222222"
              />
              <path
                  d="M6.66675 6.6665H8.18924L10.0001 9.89129L11.8109 6.6665H13.3334L11.0843 10.3535H12.6183V11.0047H10.6806L10.6691 11.0152V11.9186H12.6183V12.5699H10.6691V14.1665H9.33111V12.5699H7.39339V11.9186H9.33111V11.0152L9.31957 11.0047H7.39339V10.3535H8.91588L6.66675 6.6665Z"
                  fill="black"
              />
            </svg>
            申请记录
          </p>
        </el-table-column>
        <el-table-column label="近7天" prop="d7"></el-table-column>
        <el-table-column label="近15天" prop="d15"></el-table-column>
        <el-table-column label="近1个月" prop="m1"></el-table-column>
        <el-table-column label="近3个月" prop="m3"></el-table-column>
        <el-table-column label="近6个月" prop="m6"></el-table-column>
      </el-table>
    </card>
	</div>
</template>

<script>
import { getOrderRiskReviewDetailAPI } from "./api";

export default {
	name: "JiShen",

	data() {
		return {
			detail: {},
			alipay: {},
			baiRong: {},
			youFen: {},
			rankToColorMap: new Map([
				["RANK1", { color: "#28D576", label: "极低风险" }],
				["RANK2", { color: "#28D5D5", label: "低风险" }],
				["RANK3", { color: "#1483EA", label: "中风险" }],
				["RANK4", { color: "#FFAC46", label: "高风险" }],
				["RANK5", { color: "#D05252", label: "极高风险" }],
			]),
      enableHitScore: false,
		};
	},
	computed: {
		member() {
			return this.detail.member || {};
		},
		finalLevel() {
			return this.detail.orderScoreProfile
				? this.detail.orderScoreProfile.finalHitGrade
				: "";
		},
		scoreProfileData() {
			return this.detail.scoreProfileData || {};
		},
		riskListTable() {
			return this.alipay?.riskList || [];
		},
		importantInfoMark() {
			return [
        {
          name: "优分",
          riskName: "金融黑名单等级",
          riskValue: this.renderText(this.youFen.blacklistLevel),
          reviewSuggestions: "TODO",
        },
				{
					name: "优分",
					riskName: "运营商在网时长",
					riskValue: this.renderText(this.youFen.netTime),
					reviewSuggestions: "TODO",
				},
				{
					name: "优分",
					riskName: "自然人可信度识别",
					riskValue: this.renderText(this.youFen.identityCredence),
					reviewSuggestions: "TODO",
				},
        {
          name: "优分",
          riskName: "综合风险验证",
          riskValue: this.renderText(this.youFen.riskCheck || '暂无数据'),
          reviewSuggestions: "TODO",
        },
        {
          name: "优分",
          riskName: "疑似养卡",
          riskValue: this.renderText(this.youFen.suspendCard || '暂无数据'),
          reviewSuggestions: "TODO",
        },
				{
					name: "百融",
					riskName: "反欺诈评分",
					riskValue: this.renderText(this.baiRong.afRuleScore),
					reviewSuggestions: "TODO",
				},
				{
					name: "百融",
					riskName: "债偿压力指数",
					riskValue: this.renderText(this.baiRong.debtRepayStress),
					reviewSuggestions: "TODO",
				},
			];
		},
		courtRiskInfo() {
			if (!this.youFen.personInvolvement) {
				return [];
			}

			return [
				{
					count: this.renderText(this.youFen.personInvolvement.count),
					judgeDocumentCount: this.renderText(this.youFen.personInvolvement.judgeDocumentCount),
					openCourtNoticeCount: this.renderText(
						this.youFen.personInvolvement.openCourtNoticeCount
					),
					executeNoticeCount: this.renderText(this.youFen.personInvolvement.executeNoticeCount),
					dishonestyNoticeCount: this.renderText(
						this.youFen.personInvolvement.dishonestyNoticeCount
					),
					caseProduceCount: this.renderText(this.youFen.personInvolvement.caseProduceCount),
					exposureCount: this.renderText(this.youFen.personInvolvement.exposureCount),
				},
			];
		},
		personInvolvement() {
			if (!this.youFen.personInvolvement || !this.youFen.personInvolvement.list) {
				return [];
			}

			return this.youFen.personInvolvement.list.map((row, index) => {
				return {
					index: index + 1,
					caseTime: this.renderText(row.caseTime),
					dataType: this.renderText(row.dataType),
					title: this.renderText(row.title),
					content: this.renderText(row.content),
				};
			});
		},
		systemScoreDetail() {
			return (this.detail.hitScoreBillList ?? []).map((record, index) => {
				return {
					index: index + 1,
					ruleName: this.renderText(record.ruleName),
					hitScore: this.renderText(record.hitScore),
					hitSuggestDesc: this.renderText(record.hitSuggestDesc),
				};
			});
		},
    yfMulti1Info() {
      return [
        {
          applyOrgNum: this.renderText(this.youFen.applyOrgNum || '暂无数据'),
          m12OverdueNum: this.renderText(this.youFen.m12OverdueNum || '暂无数据'),
          m24OverdueNum: this.renderText(this.youFen.m24OverdueNum || '暂无数据'),
        },
      ];
    },
    yfMulti2Info() {
      return [
        {
          overdueRecentlyDay: this.renderText(this.youFen.overdueRecentlyDay || '暂无数据'),
          overdueHistoryDay: this.renderText(this.youFen.overdueHistoryDay || '暂无数据'),
          overdueMaxMoneyRecentlyDay: this.renderText(this.youFen.overdueMaxMoneyRecentlyDay || '暂无数据'),
          overdueMaxMoneyHistoryDay: this.renderText(this.youFen.overdueMaxMoneyHistoryDay || '暂无数据'),
        },
      ];
    },
		brApplyRecord() {
			return [
				{
					title: "线上消费分期的次数",
					d7: this.renderText(this.baiRong.d7CoonAllNum),
					d15: "-",
					m1: "-",
					m3: "-",
					m6: "-",
				},
				{
					title: "线上消费分期的机构数",
					d7: this.renderText(this.baiRong.d7CoonOrgNum),
					d15: "-",
					m1: "-",
					m3: "-",
					m6: "-",
				},
				{
					title: "持牌小贷机构申请次数",
					d7: this.renderText(this.baiRong.d7NbankSloanAllNum),
					d15: "-",
					m1: "-",
					m3: "-",
					m6: "-",
				},
				{
					title: "持牌小贷机构申请机构数",
					d7: this.renderText(this.baiRong.d7NbankSloanOrgNum),
					d15: "-",
					m1: "-",
					m3: "-",
					m6: "-",
				},
				{
					title: "持牌融资租赁机构申请次数",
					d7: "-",
					d15: this.renderText(this.baiRong.d15NbankFinleaAllNum),
					m1: "-",
					m3: "-",
					m6: "-",
				},
				{
					title: "非银机构周末申请机构数",
					d7: "-",
					d15: this.renderText(this.baiRong.d15NbankWeekOrgNum),
					m1: "-",
					m3: "-",
					m6: "-",
				},
				{
					title: "非银机构申请次数",
					d7: "-",
					d15: "-",
					m1: this.renderText(this.baiRong.m1IdNbankAllNum),
					m3: this.renderText(this.baiRong.m3IdNbankAllNum),
					m6: this.renderText(this.baiRong.m6NbankAllNum),
				},
				{
					title: "申请汽车金融的机构数",
					d7: "-",
					d15: "-",
					m1: this.renderText(this.baiRong.m1AfOrgNum),
				},
				{
					title: "非银机构-其他申请次数",
					d7: "-",
					d15: "-",
					m1: "-",
					m3: "-",
					m6: this.renderText(this.baiRong.m6NbankOthAllNum),
				},
				{
					title: "非银机构-消费类分期机构申请次数",
					d7: "-",
					d15: "-",
					m1: "-",
					m3: "-",
					m6: this.renderText(this.baiRong.m6NbankCfAllNum),
				},
				{
					title: "按身份证号查询在非银机构申请次数",
					d7: "-",
					d15: "-",
					m1: "-",
					m3: "-",
					m6: this.renderText(this.baiRong.m6IdNbankAllNum),
				},
			];
		},
	},
	mounted() {
    this.enableHitScore = this.$route.query.orderType == 2 || this.$route.query.orderType == 4;
		this.getRiskReview();
	},
	methods: {
		renderText(value) {
			return value ?? "-";
		},
		async getRiskReview() {
			const res = await getOrderRiskReviewDetailAPI(this.$route.params.id);
			this.detail = res;
			// this.alipay = res.alipay;
			this.baiRong = res.baiRong;
			this.youFen = res.youFen;
		},
	},
};
</script>

<style lang="scss" scoped>
.card {
	border-radius: 16px;
	margin-bottom: 20px;
}

.danger-cell {
	color: red;
}
.without-layout .wrapper-jishen /deep/ {
  padding: 0 24px !important;
	flex: 1;
	overflow-y: scroll;
	margin-top: 15px;
	.table-svg-header {
		display: flex;
		gap: 5px;
		align-items: center;
	}
	.el-table__header .el-table__cell {
		font-weight: 600;
	}
	.performance-records-table tbody tr:not(:last-child) td {
		&:first-child {
			background: #faeeee;
		}
		color: #d05252;
	}
}
.rank-tag {
	display: flex;
	height: 25px;
	width: 88px;
	justify-content: center;
	align-items: center;
	color: #fff;
	border-radius: 25px;
}

.online-summary {
	display: flex;
	flex-wrap: wrap;
	row-gap: 16px;
	column-gap: 16px;
	margin-bottom: 12px;

	.online-summary-item {
		width: calc(50% - 8px);
		background-color: #f7f8fa;
		border-radius: 8px;
		padding: 16px;

		.online-summary-item-header {
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 12px;
			color: #222222;
			display: flex;
			align-items: center;
			gap: 5px;
		}

		.online-summary-item-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 22px;

			&:not(:last-child) {
				margin-bottom: 12px;
			}

			& > span:first-child {
				color: #666666;
			}

			& > span:last-child {
				color: #222222;
			}

			&.danger-row span {
				color: #d05252 !important;
			}
		}
	}
}

.base-info-new {
	border-color: transparent;
	margin-top: 20px;
	width: 100%;
	border-radius: 16px;
	color: #222222;
	.base-info-top {
		display: flex;
		align-items: flex-start;
		.id-card-pic {
			margin-right: 3%;
		}
		.person-info {
			position: relative;
			flex: 1;
			display: flex;
			flex-direction: column;
			line-height: 35px;

			.mr50 {
				margin-right: 50px;
			}
			.el-tag {
				height: 25px;
				border-radius: 15px;
				margin-right: 10px;
				line-height: 25px;
			}
			.history-tag {
				.el-tag {
					height: 28px;
					line-height: 28px;
					margin-top: 20px;
				}
			}
			.el-tag.el-tag--success {
				background-color: #fff;
				color: #666666;
				border-color: #e4e4e4;
			}
			.name {
				color: #222222;
				font-size: 18px;
				font-family: 微软雅黑;
				margin-right: 2%;
			}
			.rating {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				font-size: 16px;
				.edit-btn {
					font-size: 12px;
				}
			}
		}
	}
}
.tag-ku {
	padding: 4px 12px;
	border-radius: 46px;
	font-size: 12px;
	margin-right: 5px;
	color: #fff;
	.el-icon-warning {
		color: #fff;
		font-size: 14px;
		margin-right: 5px;
	}
}
// 黑名单
.t1 {
	background-color: #d05252;
}
.t2 {
	background-color: #fbb438;
}
// 白名单
.t3 {
	background: #4cd2a2;
}
</style>
